// src/services/passStorage.js
/**
 * ✅ Single source of truth for V1.1 entitlement (PASS)
 * - Time-based expiry only
 * - MUST NOT be cleared by trophy/progress resets
 */
const LS_KEY = "pwp_pass_v11";

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function nowMs() {
  return Date.now();
}

export function getPass() {
  const raw = localStorage.getItem(LS_KEY);
  const data = raw ? safeParse(raw) : null;
  return data && typeof data === "object" ? data : null;
}

export function setPass(passObj) {
  localStorage.setItem(LS_KEY, JSON.stringify(passObj));
}

export function clearPass() {
  localStorage.removeItem(LS_KEY);
}

export function getExpiry() {
  const pass = getPass();
  return pass?.expiresAt ?? null;
}

export function hasActivePass() {
  const pass = getPass();
  if (!pass) return false;

  const expiresAt = Number(pass.expiresAt);
  if (!expiresAt) return false;

  const expired = nowMs() >= expiresAt;
  if (expired) {
    if (pass.status !== "expired") setPass({ ...pass, status: "expired" });
    return false;
  }

  return pass.status === "active";
}

/** ✅ MOCK helper (no Razorpay) */
export function setMockPass({ planId, durationDays }) {
  const startAt = nowMs();
  const expiresAt = startAt + Number(durationDays) * 24 * 60 * 60 * 1000;

  setPass({
    startAt,
    expiresAt,
    planId,
    status: "active",
    orderId: `mock_order_${startAt}`,
    paymentId: `mock_pay_${startAt}`,
  });
}

/** ✅ LIVE helper (we’ll use later after server verify) */
export function setPassFromPayment({
  planId,
  startAt,
  expiresAt,
  orderId,
  paymentId,
  status = "active",
}) {
  setPass({
    planId,
    startAt: Number(startAt),
    expiresAt: Number(expiresAt),
    orderId: orderId || null,
    paymentId: paymentId || null,
    status,
  });
}
